export const DEVELOPERS_OPERATION_START = 'DEVELOPERS_OPERATION_START';
export const DEVELOPERS_OPERATION_END = 'DEVELOPERS_OPERATION_END';

export const FETCH_DEVELOPERS_PROJECTS = 'FETCH_DEVELOPERS_PROJECTS';
export const FETCH_DEVELOPERS_PROJECTS_FINANCIAL = 'FETCH_DEVELOPERS_PROJECTS_FINANCIAL';
export const FETCH_DEVELOPERS_PROFESSIONS = 'FETCH_DEVELOPERS_PROFESSIONS';
export const FETCH_DEVELOPERS_PROGRESS_REPORT = 'FETCH_DEVELOPERS_PROGRESS_REPORT';
export const FETCH_DEVELOPERS_LATEST_PROGRESS_REPORT = 'FETCH_DEVELOPERS_LATEST_PROGRESS_REPORT';
export const FETCH_DEVELOPERS_PROJECT_UNIT = 'FETCH_DEVELOPERS_PROJECT_UNIT';

export const FETCH_DEVELOPERS_SERVICES_CHARGES = 'FETCH_DEVELOPERS_SERVICES_CHARGES';
export const FETCH_DEVELOPERS_SERVICES_CHARGES_GROUPS = 'FETCH_DEVELOPERS_SERVICES_CHARGES_GROUPS';
export const FETCH_DEVELOPERS_SERVICES_CHARGES_GROUP_DATA = 'FETCH_DEVELOPERS_SERVICES_CHARGES_GROUP_DATA';

export const ADD_TO_DEVELOPERS_ERROR_INITITATE = 'ADD_TO_DEVELOPERS_ERROR_INITITATE';
export const ADD_TO_DEVELOPERS_ERROR = 'ADD_TO_DEVELOPERS_ERROR';

export const DOWNLOAD_TRANSACTION = 'DOWNLOAD_TRANSACTION';
export const DOWNLOAD_TRANSACTION_SUCCESS = 'DOWNLOAD_TRANSACTION_SUCCESS';
export const DOWNLOAD_TRANSACTION_ERROR = 'DOWNLOAD_TRANSACTION_ERROR';

export const DOWNLOAD_CERTIFICATE = 'DOWNLOAD_CERTIFICATE';
export const DOWNLOAD_CERTIFICATE_SUCCESS = 'DOWNLOAD_CERTIFICATE_SUCCESS';
export const DOWNLOAD_CERTIFICATE_ERROR = 'DOWNLOAD_CERTIFICATE_ERROR';

export const RESET_DEVELOPERS_STATE = 'RESET_DEVELOPERS_STATE';
